Vue.component('header-messages', require('./Messages.vue').default);
Vue.component('header-favorites', require('./Favorites.vue').default);
Vue.component('header-logo', require('./Logo.vue').default);
Vue.component('header-prime', require('./Prime.vue').default);
Vue.component('header-basket', require('./Basket.vue').default);
Vue.component('header-search', require('./Search.vue').default);
